import {BaseContainerModel} from '../base-container.model';
import {bl_pgw_label_hdr_RowClass} from '../../dbschema';

export class PgwLabelHeaderContainerModel extends BaseContainerModel {
  bl_pgw_label_hdr: bl_pgw_label_hdr_RowClass = new bl_pgw_label_hdr_RowClass();
}
